export function LogoMark({ className = 'h-8 w-8' }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      data-testid="logo-mark"
    >
      <rect x="4" y="18" width="10" height="8" rx="1.5" fill="currentColor" />
      <rect x="18" y="18" width="10" height="8" rx="1.5" fill="currentColor" />
      <rect x="4" y="8" width="10" height="8" rx="1.5" fill="currentColor" />
      <rect x="18" y="6" width="10" height="8" rx="1.5" fill="#D4F36B" />
    </svg>
  );
}

export default function Logo({ dark = false, testid = 'site-logo' }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid={testid}>
      <LogoMark className={`h-8 w-8 ${dark ? 'text-offwhite' : 'text-charcoal'}`} />
      <span
        className={`font-heading text-[15px] font-extrabold leading-[1.05] tracking-tight ${
          dark ? 'text-offwhite' : 'text-charcoal'
        }`}
      >
        BUILD MY
        <br />
        TRADE
      </span>
    </span>
  );
}
